'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('../util');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      // Allow setting parent containers to pointer-events: none for
      // clickthrough while making sure buttons stay clickable
      pointerEvents: ['auto', '!important'],
      display: 'inline-block',
      color: [theme.colorButton, '!important'],
      height: theme.buttonSize,
      width: theme.buttonSize,
      borderRadius: 0,
      border: 'none',
      cursor: 'pointer',
      appearance: 'none',
      '&:first-child': {
        borderLeftWidth: [4, '!important']
      },
      '&:last-child': {
        borderRightWidth: [4, '!important']
      },
      '&:focus': {
        outline: [[1, 'dotted', 'currentColor']]
      },
      '&:focus, &:active': {
        transform: 'translate3D(1px, 1px 0)'
      },
      '&[disabled]': {
        background: [theme.bgButton, '!important'],
        cursor: 'not-allowed'
      }
    },
    accept: {
      background: [theme.accept, '!important']
    },
    reject: {
      background: [theme.reject, '!important']
    },
    ignore: {
      background: [theme.ignore, '!important']
    },
    undo: {
      background: [theme.undo, '!important']
    },
    icon: {
      position: 'relative',
      zIndex: 10
    }
  };
};

var ActionButton = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(ActionButton, _React$Component);

  function ActionButton() {
    _classCallCheck(this, ActionButton);

    return _possibleConstructorReturn(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).apply(this, arguments));
  }

  _createClass(ActionButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          title = _props.title,
          disabled = _props.disabled,
          onClick = _props.onClick,
          ButtonBase = _props.ButtonBase,
          classes = _props.classes;
      var btnClass = (0, _classnames2["default"])('prodigy-button-' + type, classes.root, classes[type]);
      var btnProps = {
        className: btnClass,
        onClick: onClick,
        'aria-label': title,
        title: title,
        disabled: disabled
      };

      var icon = _react2["default"].createElement(_Icon2["default"], {
        name: type,
        size: '40',
        className: classes.icon
      });

      return ButtonBase ? _react2["default"].createElement(ButtonBase, btnProps, icon) : _react2["default"].createElement('button', btnProps, icon);
    }
  }]);

  return ActionButton;
}(_react2["default"].Component), _class2.propTypes = {
  type: _propTypes2["default"].oneOf(['accept', 'reject', 'ignore', 'undo']),
  title: _propTypes2["default"].string,
  onClick: _propTypes2["default"].func,
  disabled: _propTypes2["default"].bool
}, _temp)) || _class);
exports["default"] = ActionButton;